import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { logout } from '../action';
import history from '../../../config/history';

class AuthMenu extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth) {
            window.location.reload();
        }
    
    }

   
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    logOut(){
        this.props.logout()
        history.push('/')
    }
    render() {
        const { auth } = this.props;
        
        // Get initial for avatar
        const getInitial = (name) => {
            if (!name) return 'U';
            return name.charAt(0).toUpperCase();
        };

        return (
            <div className="auth-menu-dropdown">
                <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle nav>
                        {auth ? (
                            <>
                                <div className="user-avatar">
                                    {getInitial(auth.name)}
                                </div>
                                <span className="user-name">{auth.name}</span>
                                <i className="fa fa-chevron-down chevron-icon"></i>
                            </>
                        ) : null} 
                    </DropdownToggle>
                    <DropdownMenu right>
                        {auth && (
                            <div className="user-header-info">
                                <span className="user-label">Signed in as</span>
                                <span className="user-full-name">{auth.name}</span>
                            </div>
                        )}
                        <DropdownItem onClick={() => this.logOut()} className="text-danger">
                            <i className="fa fa-sign-out"></i> Logout
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    }
}

function mapStateToProps({ auth }) {
    return {
        auth
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthMenu);
